// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ReactNode} from 'react';
import cn from 'classnames';
import {Cards, i_card, i_cls_obj} from '../../../../hola/pub/ui/cards';
import styles from './nav_menu.module.less';

interface i_menu_cards_props {
    cards: i_card[];
    cls?: i_cls_obj;
    children?: ReactNode;
    group_by_two?: boolean;
}
export const Menu_cards = (props: i_menu_cards_props)=>{
    const {cards = [], cls, children, group_by_two = false} = props;
    return <div className={styles.menu_cards}>
      <Cards cards={cards} cls={cls} group_by_two={group_by_two}
        spacer={<div className={cn(styles.card_spacer,
          group_by_two && styles.horizontal)}/>}/>
      {children}
    </div>;
};
